<template>
  <div class="can-pedalsure hp-block-container">
    <h2 class="hp-block-title">What does triathlon insurance cover?</h2>
    <div class="hp-prose">
      <p>
        Pedalsure provides specialist triathlon and duathlon insurance.
        Sportives and charity multi-sport events where no winner is selected
        don’t need competition cover – no extra selection needed.
      </p>
      <p>
        Taking part in an organised triathlon or duathlon event where a winner
        is selected? Add the Competition &amp; Racing Use option to your policy,
        at an additional premium, and cover extends to your bike in transition
        and to you on the swim and run legs.
      </p>
    </div>
    <div class="element-container hp-cards">
      <div>
        <b>Theft</b>: Your bike is covered against theft as standard. Add
        Competition &amp; Racing Use for an organised event with a winner and
        cover extends to the transition area, so you don’t need to worry about
        your bike not being there when you come out of the water.
      </div>
      <div>
        <b>Accidental damage</b>: With Theft and Accidental Damage cover, you’re
        covered whether you’ve dropped your bike or damaged it out on a
        sportive. Add Competition &amp; Racing Use for an organised event with a
        winner and you’re covered on the transition racks too.
      </div>
      <div>
        <b>Personal injury</b>: Add personal accident cover and you’re covered
        on the bike leg. Add Competition &amp; Racing Use for an organised event
        with a winner and you’re also covered during the running and swimming
        phases.
      </div>
      <div>
        <b>Public liability</b>: If someone else gets injured or their property
        is damaged, we'll take care of it.
      </div>
      <div>
        <b>Overseas travel</b>: We can provide peace of mind for your
        international triathlon events, including transit.
      </div>
      <div>
        <b>Loss of earnings</b>: Injure yourself and can't work? We can cover
        you with weekly payments.
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.can-pedalsure {
  border-top: 1px solid $ps-border;
  border-bottom: 1px solid $ps-border;
}

.title {
  text-align: center;
  font-family: $family-regular;
  margin: 20px 0 0 0;
  font-size: 1.6rem;
  @include tablet {
    margin: 50px 0;
    font-size: 2.5rem;
  }
}
.subtitle {
  color: $ps-gray;
  line-height: 2rem;
}
</style>
